import createReducer from '../createReducer'
import {
  FETCH_CONSENT_MATRIX_SUCCESS,
  FETCH_CONSENT_MATRIX_LOADING,
  FETCH_CONSENT_STATUS_SUCCESS,
  INITIATE_COUNTRY_CONFIRMATION,
  CANCEL_COUNTRY_CONFIRMATION,
  STAGE_UNCONSENTED_LIST,
  STAGE_CONSENT_SCREEN_NAME,
} from './constants'

export const initialState = {
  matrix: {},
  matrixLoading: false,
  status: {},
  confirmCountry: null,
  stagedUnconsentedList: [],
  stagedScreenName: '',
}

export default createReducer(initialState, {

  name: 'consents',

  [FETCH_CONSENT_MATRIX_SUCCESS]: (state, action) => {
    const matrix = action.payload.data.item
    const matrixLoading = false
    return { ...state, matrix, matrixLoading }
  },
  [FETCH_CONSENT_MATRIX_LOADING]: (state) => {
    const matrixLoading = true
    return { ...state, matrixLoading }
  },
  [FETCH_CONSENT_STATUS_SUCCESS]: (state, action) => {
    const status = action.payload.data.item
    return { ...state, status }
  },
  [INITIATE_COUNTRY_CONFIRMATION]: (state, action) => {
    const confirmCountry = action.payload
    return { ...state, confirmCountry }
  },
  [CANCEL_COUNTRY_CONFIRMATION]: (state) => {
    const confirmCountry = null
    return { ...state, confirmCountry }
  },
  [STAGE_UNCONSENTED_LIST]: (state, action) => {
    return { ...state, stagedUnconsentedList: action.payload }
  },
  [STAGE_CONSENT_SCREEN_NAME]: (state, action) => {
    return { ...state, stagedScreenName: action.payload }
  },
})



// WEBPACK FOOTER //
// ./src/services/consents/reducer.js